import { Box, Stack, Theme } from '@mui/material';
import { withClarityTheme } from '@verifime/styles';

const CompanyLogoComponent = ({
  companyName,
  companyLogoUrl,
}: {
  companyName: string;
  companyLogoUrl?: string;
}) => {
  if (!companyLogoUrl) {
    return null;
  }

  const logoBorder = (theme: Theme) => `${theme.card.borderWidth} solid ${theme.palette.grey[100]}`;

  return (
    <Stack
      sx={(theme) => ({
        backgroundColor: theme.palette.surface.logo,
        width: theme.logo.width,
        aspectRatio: '4 / 1',
        padding: theme.logo.padding,
        borderRadius: theme.logo.borderRadius,
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        border: logoBorder(theme),
      })}
    >
      <Box
        component="img"
        src={companyLogoUrl}
        alt={`${companyName} logo`}
        sx={{
          width: '100%',
          height: '100%',
          objectFit: 'contain',
          objectPosition: 'center',
        }}
      />
    </Stack>
  );
};

export const CompanyLogo = withClarityTheme(CompanyLogoComponent);
